import { motion } from "framer-motion";
import { useLanguage } from "../../i18n/LanguageContext";

interface Props {
  value: number;
  max?: number;
  label?: string;
}

export default function WLBGauge({ value, max = 10, label }: Props) {
  const { t } = useLanguage();
  const displayLabel = label ?? t.player.wlb;
  return (
    <div className="space-y-1">
      <div className="flex justify-between text-xs text-white/50">
        <span>{displayLabel}</span>
        <span>{value}/{max}</span>
      </div>
      <div className="flex gap-0.5">
        {Array.from({ length: max }, (_, i) => {
          const filled = i < value;
          let color = "bg-wlb-high";
          if (value <= 2) color = "bg-wlb-low";
          else if (value <= 5) color = "bg-wlb-mid";
          return (
            <motion.div
              key={i}
              className={`h-2 flex-1 rounded-sm transition-colors duration-300 ${filled ? color : "bg-white/10"}`}
              animate={filled && value <= 2 ? { opacity: [1, 0.3, 1] } : {}}
              transition={{ repeat: Infinity, duration: 0.8 }}
            />
          );
        })}
      </div>
    </div>
  );
}
